export function isSelectableUser(u) {
  if (!u) return false;
  const sil = u.KUL_SIL === true || u.KUL_SIL === 1;
  const adi = String(u.KUL_ADI || '').trim().toUpperCase();
  return !sil && !adi.startsWith('ZZZ');
}

export function getSelectableUsers(users) {
  return (Array.isArray(users) ? users : []).filter(isSelectableUser);
}

export function atananDisplayName(row, users) {
  const named = String(row?.ATANAN_AD || '').trim();
  if (named) return named;
  const ref = Number(row?.CAR_ARA_KUL_REF);
  if (!Number.isFinite(ref) || ref <= 0) return '';
  const user = (Array.isArray(users) ? users : []).find((item) => Number(item?.KUL_REF) === ref);
  return String(user?.KUL_ADI || ref).trim();
}

export function getSelectableUsersWithIncluded(users, includeRefs) {
  const list = Array.isArray(users) ? users : [];
  const base = getSelectableUsers(list);
  const refs = new Set((Array.isArray(includeRefs) ? includeRefs : []).map((x) => Number(x)).filter((x) => Number.isFinite(x)));
  if (!refs.size) return base;
  const byRef = new Map(base.map((u) => [Number(u.KUL_REF), u]));
  for (const u of list) {
    const ref = Number(u?.KUL_REF);
    if (refs.has(ref) && !byRef.has(ref)) byRef.set(ref, u);
  }
  return Array.from(byRef.values());
}
